/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone, faTrash, faCaretRight, faMapMarkerAlt, faEnvelope, faCheck, faDoorOpen, faGlobe, faUser, faRulerCombined, faInfoCircle, faUserCircle, faUserTie, faRocket, faMedal, faCoins, faCalculator, faCheckCircle, faClock, faEuroSign, faChartLine, faPlusCircle, faEdit, faTrashAlt, faMoneyBillWave, faExternalLinkAlt, faHandHoldingUsd, faStar, faListAlt, faBan, faTachometerAlt, faUsers, faCubes, faDollarSign, faComments, faCogs, faFlagCheckered, faAngleLeft, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { dom } from "@fortawesome/fontawesome-svg-core";

// Add all icons that are used in the application
library.add(
  faPhone, faTrash, faCaretRight, faMapMarkerAlt, faEnvelope, faCheck, faDoorOpen, faGlobe, 
  faUser, faRulerCombined, faInfoCircle, faUserCircle, faUserTie, 
  faRocket, faMedal, faCoins, faCalculator, faCheckCircle, faClock, 
  faEuroSign, faChartLine, faPlusCircle, faEdit, faTrashAlt, 
  faMoneyBillWave, faExternalLinkAlt, faHandHoldingUsd, faStar, 
  faListAlt, faBan, faTachometerAlt, faUsers, faCubes, faDollarSign, 
  faComments, faCogs, faFlagCheckered, faAngleLeft, faSignOutAlt
);

// Replace any existing <i> tags with <svg> and set up the auto-replacement for future elements
dom.watch();

require("./bootstrap");
var Lang = require("./lang.js").default;
// import translations from './messages.js';

// var lang = new Lang();
// lang.setLocale('en');
// lang.setMessages(translations);

let _ = require("lodash");
let $ = require("jquery");

// $(function () {
//     $("#datepicker").datepicker({
//         dateFormat: "dd.mm.yy",
//         altFormat: "yy-mm-dd",
//         altField: "#event_date",
//         // Needed to notify VueJS
//         onSelect: function(selectedDate, datePicker){
//             var event = new Event("input");
//             this.dispatchEvent(event);
//         }
//     });
// });

window.Vue = require('vue').default;

window.VueGoogleMaps = require("vue2-google-maps");
// import * as VueGoogleMaps from 'vue2-google-maps'
import BootstrapVue from "bootstrap-vue"

Vue.use(BootstrapVue);
Vue.use(require('vue-cookies'))

Vue.filter("trans", function (...args) {
    return Lang.get(...args);
})

Vue.prototype.trans = function(...args) {
    return Lang.get(...args);
}

Vue.filter("trans_choice", function (...args) {
    return Lang.choice(...args);
})

Vue.use(window.VueGoogleMaps, {
    load: {
        key: "AIzaSyDR9golpXQ2XywGDoXVo2cTxpB5KgXOzu8",
        //libraries: "places", // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)
    }
})

import OldValue from './components/OldValue.vue';
import EntryMapComponent from './components/EntryMapComponent.vue';
import Map from './components/Map.vue';
import ModerationForm from './components/ModerationForm.vue';
import EntryForm from './components/EntryForm.vue';
import EditRevisionForm from './components/EditRevisionForm.vue';
import DatePicker from './components/DatePicker.vue';
import InnerForm from './components/InnerForm.vue';
import DuplicatesView from './components/DuplicatesView.vue';
import RatingStar from './components/RatingStar.vue';
import RatingBar from './components/RatingBar.vue';
import SearchFilter from './components/SearchFilter.vue';
import Vue from "vue";

Vue.component('old-value', OldValue);
Vue.component('entry-map', EntryMapComponent);
Vue.component('full-map', Map);
Vue.component('moderation-form', ModerationForm);
Vue.component('entry-form', EntryForm);
Vue.component('edit-revision-form', EditRevisionForm);
Vue.component('date-picker', DatePicker);
Vue.component('inner-form', InnerForm);
Vue.component('duplicates', DuplicatesView);
Vue.component('rating-star', RatingStar);
Vue.component('rating-bar', RatingBar);
Vue.component('search-filter', SearchFilter);

// if(typeof formData !== "undefined"){
if ($("#app").length) {
    const app = new Vue({
        el: "#app",
        data: {
            categories: typeof formData !== "undefined" ? formData.categories : null,
            months: typeof formData !== "undefined" ? formData.months : null,
            quarters: typeof formData !== "undefined" ? formData.quarters : null,
            years: typeof formData !== "undefined" ? formData.years : null,
            halfYears: typeof formData !== "undefined" ? formData.halfYears : null,
            revision: typeof formData !== "undefined" ? (formData.revision || undefined) : null,
            duplicates: [],
            isLoadingDuplicates: false,
        },
        methods: {
            onDuplicatesChange: function (duplicates) {
                this.duplicates = duplicates
            },
            onDuplicatesLoading: function (isLoading) {
                if (isLoading) {
                    this.duplicates = [];
                }
                this.isLoadingDuplicates = isLoading
            },
        }
    });
}

if ($("#app-map").length) {
    const appMap = new Vue({
        el: "#app-map"
    });
}

if ($("#app-payment").length) {
    const appPayment = new Vue({
        el: "#app-payment",
        data: {
            selected: typeof formData !== "undefined" ? formData.lastPaymentIdentifier : 1,
        },
        computed: {
            paymentIdentifierLabel: function () {
                return document.getElementById('payment-identifier-label').getAttribute('data-identifier-' + this.selected);
            }
        },
        methods: {}
    });
}

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
});
